import { BasePageDto } from "@/types/dto/base-page-dto";
import { NoticeDetailDto } from "@/types/dto/notice-detail-dto";
import { PartnerNoticeHeaderButtonGroup } from "../button-group/PartnerNoticeHeaderButtonGroup";
import { H4 } from "../typography/H4";

interface Props {
  noticePage: BasePageDto<NoticeDetailDto>;
  goToPage: (pageNumber: number) => void;
}

export const PartnerNoticeHeader: React.FC<Props> = ({
  noticePage,
  goToPage,
}) => {
  return (
    <div className="py-[16px]">
      <div className="flex items-center justify-between">
        <div className="flex">
          <H4 className="text-semantic-text-heading">공지사항</H4>
        </div>
        <PartnerNoticeHeaderButtonGroup
          noticePage={noticePage}
          goToPage={goToPage}
        />
      </div>
      <div />
    </div>
  );
};
